"use client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { fetchLeadPreview } from "../state/services";
import { useStoreSelectors } from "../store";

export default function MaskedLeadInfo({ note }) {
  const { selectCurrentStep } = useStoreSelectors();
  const currentStep = selectCurrentStep();
  const [leadPreview, setLeadPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const textColor = currentStep.stepTextColor ?? "";

  useEffect(() => {
    setLoading(true);
    fetchLeadPreview()
      .then(setLeadPreview)
      .catch(() => setLeadPreview(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (leadPreview) {
      setLoading(false);
    }
  }, [leadPreview]);

  return (
    <div className={`w-full flex flex-col items-center text-center gap-4 ${textColor}`}>
      {loading && <div className="mx-auto p-4">Loading...</div>}

      {!loading && leadPreview && (
        <>
          {leadPreview.name && <div className="md:text-2xl font-semibold">{leadPreview.name}</div>}
          <div className="md:text-2xl font-semibold">{leadPreview.email}</div>
          <div className="md:text-2xl font-semibold">{leadPreview.phone}</div>
        </>
      )}

      {note && (
        <div
          className="text-xs max-w-sm mx-auto pb-8"
          dangerouslySetInnerHTML={{ __html: note }}
        />
      )}
    </div>
  );
}

MaskedLeadInfo.propTypes = {
  note: PropTypes.string,
};




